export class ActivityType {
  static TypesActivity: any[] = [
    // { name: 'EVENEMENT', value: 'EVENEMENT' },
    { name: 'Webinaire', value: 'WEBINAIRE' },
    // { name: 'Test en Ligne', value: 'TESTENLIGNE' },
    { name: 'Bootcamp', value: 'BOOTCAMP' },
    // { name: 'Atelier', value: 'ATELIER' },
    { name: 'Atelier Force-N', value: 'ATELIER_FORCEN' },
    { name: 'Par zone de residence', value: 'PAR_ZONE_RESIDENCE' },
    { name: 'Mini JPO', value: 'MINIJPO' },
    { name: 'JPO', value: 'JPO' },
    { name: 'Masterclass', value: 'MASTERCLASS' },
    { name: 'Activité informelle', value: 'COMMERCANT_LIVREUR' },
  ];

  static TypesTest: any[] = [
    { name: 'PROFILAGE', value: 'PROFILAGE' },
    { name: 'PREREQUIS', value: 'PREREQUIS' },
  ];
}
